import React from "react"
import {getCustomerId, getTenantId} from "../../utils/Routes"
import {useLocation} from "react-router-dom"

const Wix = () => {
	useLocation()
	var tenantQueryParam: string =
		getTenantId() !== "" ? "&tenantId=" + getTenantId() : "&tenantId=VP-IE-PROD"
	const iframeSrc = `${
		process.env.REACT_APP_CARE_WIX_UI
	}/?shopperId=${getCustomerId()}${tenantQueryParam}`
	return (
		<div>
			<iframe key={iframeSrc} src={iframeSrc} title="Wix" width={"100%"} height="2000px" />
		</div>
	)
}

export default Wix
